import { UserStatus } from 'chaika-enums';
import type { UserData } from 'chaika-frontend-types/frontend-cms';

import { getUserStatusTitle } from '@store/models/User/getUserStatusTitle';
import { formatFullName } from '@utils/formatFullName';

import { getInitials } from './getInitials';

interface Options {
    /** Full name (Petrov (Sidorov) Ivan Sergeevich). Wins over `withInitials`. */
    withFullName?: boolean;
    /** Initials (Petrov I. S.). */
    withInitials?: boolean;
}

/**
 * Canonical label for a user in selects/filters. When neither flag is set,
 * falls back to `${lastName} ${firstName}`. Always appends the archived-status
 * title in parentheses for archived users so they're visually distinguishable
 * wherever they appear.
 */
export function makeUserLabel(user: UserData, { withFullName, withInitials }: Options = {}): string {
    let base: string;
    if (withFullName) {
        base = formatFullName(user);
    } else if (withInitials) {
        base = getInitials(user);
    } else {
        base = `${user.lastName || ''} ${user.firstName || ''}`;
    }

    if (user.status === UserStatus.Archived) {
        return `${base} (${getUserStatusTitle(UserStatus.Archived)})`;
    }
    return base;
}
